import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";

export const LetsgoPage = () => {
	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			minHeight="80vh"
			bgcolor="background.default"
			px={2}
		>
			<Card sx={{ maxWidth: 500, textAlign: "center", p: 2 }}>
				<CardHeader
					title="🎉 Let's go!"
					titleTypographyProps={{ variant: "h4", align: "center" }}
				/>
				<CardContent>
					<Typography variant="body1" gutterBottom>
						We sent to your email a link to submit your answers for this form.
					</Typography>
					<Typography variant="body2" color="text.secondary" gutterBottom>
						You can now check your email, and click on the link to submit your
						responses.
					</Typography>
				</CardContent>
			</Card>
		</Box>
	);
};
